export const INITIATE_EPAY_ORDER = 'INITIATE_EPAY_ORDER';
export const SET_EPAY_FORM_FIELDS = 'SET_EPAY_FORM_FIELDS';
export const SET_PAYMENT_STATUS = 'SET_PAYMENT_STATUS';
export const SET_PAYMENT_KEY = 'SET_PAYMENT_KEY';
export const SET_PROCESSING_PAYMENT_MODAL_OPENED = 'SET_PROCESSING_PAYMENT_MODAL_OPENED';